module.exports = __webpack_public_path__ + "img/remittance-bg.f158c356.svg";